import gsap from 'gsap';

const animationEnter = (container) => {

    return gsap.from('.ss-main', { autoAlpha:0, duration: .7, clearProps: 'all', ease: 'none' })

    // const activeLink = container.querySelector('a.is-active span');
    // const projects = container.querySelectorAll('.project');
    // const images = container.querySelectorAll('.image');
    // const img = container.querySelectorAll('img');

    // const tl = gsap.timeline({
    //     defaults: {
    //         duration: .9, ease: 'power4.out'
    //     }
    // })

    // tl
    //     .set(projects, { autoAlpha: 1, stagger: .2 })
    //     .fromTo(activeLink, { xPercent: -101 }, { xPercent: 0, transformOrigin: 'left' }, 0)
    //     .from(images, {xPercent: -101, stagger: .2}, 0)
    //     .from(img, {xPercent: 101, stagger: .2}, 0)

    //     // tl.timeScale(0.2)

    // return tl
}

export default animationEnter;